import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Validation } from '../../helper';
import { AuthActions } from '../../actions';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Submit, Input } from '../Form';
import {faSpinner, faLockOpen, faExclamationCircle} from '@fortawesome/fontawesome-free-solid';

class LoginForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            error: {
                email: false,
                password: false
            },
            allowShowError: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    validation() {
        var err = {
            email: false,
            password: false
        
        }
        if(!Validation.password(this.state.password)) err.password = true;
        if(!Validation.email(this.state.email)) err.email = true;        

        this.setState({error: err});
        
        return !err.email && !err.password;
    }

    handleSubmit (event) {
        event.preventDefault();

        // if reuest in process
        if(this.props.auth.process === true) return;

        // validation ok 
        if(this.validation()) {
            // redirect user to the original page request
            const redirect = this.props.auth.redirect ? this.props.auth.redirect.from : false;
            const {dispatch} = this.props;

            this.setState({allowShowError: true});

            dispatch(AuthActions.login({
                email: this.state.email,
                password: this.state.password
            }, redirect));
        }
    }

    showError () {
        // show error only if has request error & this component make login request
        if(this.props.auth.error && this.state.allowShowError) {
            return (
                <div className="showError">
                    <FontAwesomeIcon icon={faExclamationCircle}/> שם משתמש או סיסמא לא נכונים
                </div>
            )
        }
    }

    render() {
        const requestInProcess = this.props.auth.process === true;

        return (
            <div id="loginForm" className='register-form-template'>
                <div className="form-title">
                    התחברות
                </div>
                <form onSubmit={this.handleSubmit} noValidate>
                    <Input
                        name="email"
                        value={this.state.email}
                        placeholder="אימייל"
                        error={this.state.error.email}
                        errorText='אימייל לא תקין'
                        onChange={this.handleChange}
                        type="email"
                    />
                    <Input
                        name="password"
                        value={this.state.password}
                        placeholder='סיסמא (לפחות 8 תווים)'
                        error={this.state.error.password}
                        errorText='סיסמא לא תקינה'
                        onChange={this.handleChange}
                        type="password"
                    />
                    <Submit process={requestInProcess} icon="faUnlock" text="כניסה"/>
                    {this.showError()}
                </form>
                <Link to="/register"><small>אין לי חשבון</small></Link>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer
    }
}

const LoginFormWithRedux = connect(mapStateToProps)(LoginForm);

export {LoginFormWithRedux as LoginForm};


// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginForm.jsx